import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

// Renders one custom field control by definition type. Value semantics match
// the JSONB storage: text/select → string, number → number, date → "YYYY-MM-DD".
const CustomFieldInput = ({ def, value, onChange, size = "medium" }) => {
  const common = {
    fullWidth: true,
    size,
    label: def.label,
  };

  switch (def.field_type) {
    case "number":
      return (
        <TextField
          {...common}
          type="number"
          value={value ?? ""}
          onChange={(e) => {
            const parsed = parseFloat(e.target.value);
            onChange(Number.isFinite(parsed) ? parsed : "");
          }}
        />
      );
    case "date":
      return (
        <TextField
          {...common}
          type="date"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      );
    case "select":
      return (
        <FormControl fullWidth size={size}>
          <InputLabel>{def.label}</InputLabel>
          <Select
            label={def.label}
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {(def.options || []).map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    default:
      return (
        <TextField
          {...common}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
  }
};

export default CustomFieldInput;
